import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import InputSelectFieldWithValidation from '../../../../../common/InputSelectFieldWithValidation';
import {TextareaFieldWithValidation} from '../../../../../common/TextareaFieldWithValidation';
import formMessages from '../../../../../../intl/afterSales/formMessages';
import {
    FORM_FIELD_ISSUE_IDENTIFIED,
    FORM_FIELD_PROBLEM_DESCRIPTION,
    FORM_LABEL_ISSUE_IDENTIFIED,
    FORM_LABEL_PROBLEM_DESCRIPTION,
} from '../../../../../../constants/formConstants';
import {issueIdentifiedMessages} from '../../../../../../constants/Utils';
import maintenanceInternalTicketRootCausesMessages from '../../../../../../intl/afterSales/issueIdentifiedMessages';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const ProblemDescriptionMaintenanceSection = (props) => {
    const {readOnly, reqFields, userRights} = props;
    // Only allow edit if explicitly permitted AND not readonly
    const canEditProblemDesc = userRights && userRights.canEditInternalTicketProblemDesc;
    const isFieldsDisabled = readOnly || !canEditProblemDesc;

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...formMessages.PROBLEM_DESCRIPTION_SECTION}/>
            </h3>
            <StyledDiv className="border border-secondary px-4 py-2 bg-white">
                <div className="form-row">
                    <div className="col-xl-4 col-lg-6 col-md-12 pb-1">
                        <InputSelectFieldWithValidation
                            label={formMessages[FORM_LABEL_ISSUE_IDENTIFIED]}
                            field={FORM_FIELD_ISSUE_IDENTIFIED}
                            options={issueIdentifiedMessages}
                            intlMessages={maintenanceInternalTicketRootCausesMessages}
                            isRequired={reqFields.includes(FORM_FIELD_ISSUE_IDENTIFIED)}
                            isDisabled={isFieldsDisabled}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 pr-0 pb-1">
                        <TextareaFieldWithValidation
                            label={formMessages[FORM_LABEL_PROBLEM_DESCRIPTION]}
                            field={FORM_FIELD_PROBLEM_DESCRIPTION}
                            isDisabled={isFieldsDisabled}
                            rows={6}
                            maxLength={2000}
                            isRequired={reqFields.includes(FORM_FIELD_PROBLEM_DESCRIPTION)}
                        />
                    </div>
                </div>
            </StyledDiv>
        </>
    );
};

export default injectIntl(ProblemDescriptionMaintenanceSection);
